export type CharacterSpriteState =
  | "idle"
  | "attack"
  | "hurt"
  | "defeated"
  | "victory";

export function getPlayerSpritePath(state: CharacterSpriteState): string {
  return `/assets/sprites/frames/player-${state}.png`;
}

export function getEnemySpritePath(
  variant: number,
  state: CharacterSpriteState
): string {
  const normalizedVariant = Math.min(7, Math.max(0, Math.trunc(variant)));
  const sheet = normalizedVariant < 4 ? "a" : "b";
  const row = normalizedVariant % 4;

  return `/assets/sprites/frames/enemy-${sheet}-${row}-${state}.png`;
}
